import { extend } from './extend';
import { library } from './library';
import { Runtime } from './runtime';
export var Chart = extend(Runtime, library);